module.exports = __webpack_public_path__ + "img/icon_bell.eba2e502.png";